export default {
  computed: {
    routeName() {
      return this.$route.name
    },
  },
}
